export const FILESTACK_CDN_URL = 'https://cdn.filestackcontent.com/';
export const SUPPORTED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/tiff',
  'image/bmp',
];
